import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Sidebar.css';

function Sidebar() {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  // Define navigation items with modern icons
  const navItems = [
    { path: '/', name: 'Dashboard', icon: '📊' },
    { path: '/notes', name: 'Notas', icon: '📝' },
    { path: '/tasks', name: 'Tareas', icon: '✅' },
    { path: '/updates', name: 'Updates', icon: '🔔' },
    { path: '/email', name: 'Email', icon: '✉️' },
    { path: '/chatbot', name: 'Chatbot', icon: '🤖' },
    { path: '/finance', name: 'Finanzas', icon: '💰' },
    { path: '/finance/portfolio', name: 'Portfolio', icon: '📈' },
    { path: '/news', name: 'Noticias', icon: '📰' },
    { path: '/calendar', name: 'Calendario', icon: '📅' },
    { path: '/n8n-monitor', name: 'Monitor', icon: '🔧' },
    { path: '/rituals', name: 'Rituales', icon: '🔄' },
    { path: '/journal', name: 'Diario', icon: '📖' },
    { path: '/design-showcase', name: 'Nuevo Diseño', icon: '🎨' },
    { path: '/health', name: 'Salud & Fitness', icon: '💪' },
    { path: '/settings', name: 'Configuración', icon: '⚙️' },
  ];

  async function handleLogout() {
    setError('');
    try {
      await logout();
      navigate('/login');
    } catch {
      setError('Error al cerrar sesión');
    } 
  }

  return (
    <nav className="sidebar">
      <div className="sidebar-header">
        <h2>Personal Hub</h2>
      </div>
      
      <ul className="sidebar-nav">
        {navItems.map((item) => (
          <li key={item.path}>
            <NavLink
              to={item.path}
              className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
            >
              <span className="icon">{item.icon}</span>
              {item.name}
            </NavLink>
          </li>
        ))}
      </ul>

      {currentUser && (
        <div className="sidebar-footer">
          {error && <div className="sidebar-error">{error}</div>}
          <button onClick={handleLogout} className="logout-button">
            <span>🚪</span>
            Cerrar Sesión
          </button>
          <div className="user-info">
            {currentUser.email}
          </div>
        </div>
      )}
    </nav>
  );
}

export default Sidebar; 